/*
 * Turn shapes for the client-side exchanges (salaryPrompt, spouseGoalPrompt).
 *
 * These build the entries those hooks hand to ChatView as `leadingTurns`:
 * client-only turns that are never persisted and never reach the agent. Shared
 * so a second exchange cannot invent a slightly different turn shape than the
 * first — ChatView reads `role`, `text`, `timestamp` and `suggestions`.
 */

const stamp = turn => ({ timestamp: new Date().toISOString(), ...turn })

export const userTurn = text => stamp({ role: 'user', text })

export const botTurn = (text, suggestions) => stamp({ role: 'bot', text, suggestions })
